export default {
  'pages.home': 'Home',
  'pages.about': 'Über uns',
  'pages.login_form': 'Anmeldeformular',
  'pages.signup_success': 'Erfolgreiche Anmeldung',
  'pages.create_business_profile': 'Erstellen Sie ein GeschäftsProfil',
  'pages.complete_profile': 'Profil vervollständigen',
  'pages.send_password_successfully': 'Passwort erfolgreich sende',
  'pages.forget_password': 'Passwort vergessen',
  'pages.ticket_mangment': 'Ticketverwaltung',
};
